import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { type FC } from "react";

export const IconWaves: FC<PropsWithClassName & { animating?: boolean }> = ({ className, animating }) => {
    return (
        <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M40,72s40-32,88,0,88,0,88,0"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="16"
                className="text-content-quaternary"
            />
            <path
                d="M40,72s40-32,88,0,88,0,88,0"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="16"
                strokeDasharray={256}
                strokeDashoffset={512}
                className={cn({ "animate-drawAndPause repeat-infinite": animating })}
            />

            <path
                d="M40,128s40-32,88,0,88,0,88,0"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="16"
                className="text-content-quaternary"
            />
            <path
                d="M40,128s40-32,88,0,88,0,88,0"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="16"
                strokeDasharray={256}
                strokeDashoffset={512}
                className={cn({ "animate-drawAndPause repeat-infinite": animating })}
            />

            <path
                d="M40,184s40-32,88,0,88,0,88,0"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="16"
                className="text-content-quaternary"
            />
            <path
                d="M40,184s40-32,88,0,88,0,88,0"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="16"
                strokeDasharray={256}
                strokeDashoffset={512}
                className={cn({ "animate-drawAndPause repeat-infinite": animating })}
            />
        </svg>
    );
};
